import type { TourSection } from './types';

export const dashboardSections: TourSection[] = [
  {
    id: 'kpi-cards',
    label: 'Contadores principales',
    steps: [
      {
        target: '[data-tour="dashboard-cards"]',
        title: 'Resumen del catálogo',
        content:
          'Total de productos cargados, cuántos están pendientes de completar y cuántas sugerencias de IA quedan por revisar. Click en cada tarjeta te lleva al listado correspondiente.',
      },
    ],
  },
  {
    id: 'charts',
    label: 'Gráficos',
    steps: [
      {
        target: '[data-tour="dashboard-charts"]',
        title: 'Métricas visuales',
        content:
          'Cómo está distribuido el catálogo por categoría, en qué estado están las sugerencias de IA, y cómo van las entregas de avisos a clientes externos. Se actualizan cada vez que entras.',
      },
    ],
  },
  {
    id: 'shortcuts',
    label: 'Menú lateral',
    steps: [
      {
        target: '[data-tour="sidebar-nav"]',
        title: 'Navegación',
        content:
          'Acceso a todas las secciones del panel: catálogo, pendientes, sugerencias IA, configuración. Si tu rol no permite ver una sección, no aparece en el menú.',
        placement: 'right',
      },
    ],
  },
];
